import { render, staticRenderFns } from "./RecipientOffers.vue?vue&type=template&id=6c1f8eeb"
import script from "./RecipientOffers.vue?vue&type=script&lang=ts"
export * from "./RecipientOffers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/views/offers/_locales/RecipientOffers.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Foffers%2FRecipientOffers.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports